import { Service } from '@angular/core';
import { environment } from '@env/environment';
import { Role } from '@adgate/modules/admin/types/role.type';
import { User } from '@adgate/modules/admin/types/user.type';
import { CommercialOffice } from '@adgate/common/types/commercial-office.type';
import { Agency } from '@adgate/common/types/agency.type';
import { BaseService } from '@adgate/common/services/base-service';

@Service()
export class AdminService extends BaseService
{
    private baseServiceUrl = `${environment.baseServiceUrl}admin`;

    getUsers(officeId: number | null)
    {
        let url = `${this.baseServiceUrl}/getUsers${officeId != null ? '?officeId=' + officeId : '' }`;
        return this.sendRequest(url, null, 'get');
    }

    deleteUser(userId: number)
    {
        let url = `${this.baseServiceUrl}/deleteUser/${userId}`;
        return this.sendRequest(url, null, 'delete');
    }

    updateUser(user: User)
    {
        let url = `${this.baseServiceUrl}/updateUser`;
        return this.sendRequest(url, user, 'post');
    }

    getRoles(officeAdminRolesOnly: boolean)
    {
        let url = `${this.baseServiceUrl}/getRoles?officeAdminRolesOnly=${officeAdminRolesOnly}`;
        return this.sendRequest(url, null, 'get');
    }

    deleteRole(roleId: number)
    {
        let url = `${this.baseServiceUrl}/deleteRole/${roleId}`;
        return this.sendRequest(url, null, 'delete');
    }

    updateRole(role: Role)
    {
        let url = `${this.baseServiceUrl}/updateRole`;
        return this.sendRequest(url, role, 'post');
    }

    getPrivileges()
    {
        let url = `${this.baseServiceUrl}/getPrivileges`;
        return this.sendRequest(url, null, 'get');
    }

    getCommercialOffices()
    {
        let url = `${environment.baseServiceUrl}common/getCommercialOffices`;
        return this.sendRequest(url, null, 'get');
    }

    deleteCommercialOffice(officeId: number)
    {
        let url = `${this.baseServiceUrl}/deleteCommercialOffice/${officeId}`;
        return this.sendRequest(url, null, 'delete');
    }

    updateCommercialOffice(office: CommercialOffice)
    {
        let url = `${this.baseServiceUrl}/updateCommercialOffice`;
        return this.sendRequest(url, office, 'post');
    }

    getAgencies()
    {
        let url = `${environment.baseServiceUrl}common/getAgencies`;
        return this.sendRequest(url, null, 'get');
    }

    deleteAgency(agencyId: number)
    {
        let url = `${this.baseServiceUrl}/deleteAgency/${agencyId}`;
        return this.sendRequest(url, null, 'delete');
    }

    updateAgency(agency: Agency)
    {
        let url = `${this.baseServiceUrl}/updateAgency`;
        return this.sendRequest(url, agency, 'post');
    }
}
